import React from 'react';
import { TextControls, PaginationButton } from './components';
import Icon from '../icon/Icon';

export interface RightSideControlsProps {
  pagesCount: number;
  selectedPage: number;
  onPageChange: (pageIndex: number) => void;
}

export const RightSideControls: React.FC<RightSideControlsProps> = ({ pagesCount, selectedPage, onPageChange }) => {
  const handleNextClick = () => onPageChange(selectedPage + 1);
  const handleLastClick = () => onPageChange(pagesCount);

  return (
    <TextControls>
      <PaginationButton disabled={selectedPage >= pagesCount} onClick={handleNextClick}>
        <Icon type="angle-right" />
      </PaginationButton>

      <PaginationButton disabled={selectedPage >= pagesCount} onClick={handleLastClick}>
        <Icon type="angle-double-right" />
      </PaginationButton>
    </TextControls>
  );
};
